module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/symbol/iterator.js